<template>
  <draggable-modal ref="modal" :width="600" :height="320" :autoMinHeight="true" :minWidth="400" @modalDismissed="setSelectedNodeID(null)">
    <v-card-title>
      <span class="headline">Node Pins</span>
      <v-spacer />
      <v-btn
        text
        class="ma-0 pa-0"
        @click="setSelectedNodePinsID(null)"
      >
        <v-icon x-large color="red">mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-select
            color="orange"
            readonly
            v-model="pinnedBy"
            :items="pinnedBy"
            chips
            multiple
            label="Dotted By"
            placeholder="No one has dotted this yet"
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                @click="data.select"
              >
                <v-avatar :color="data.item.avatar.color" left>
                  <span class="white--text">{{ data.item.avatar.initials }}</span>
                </v-avatar>
                {{ data.item.name }}
              </v-chip>
            </template>
            <v-icon slot="append" color="green"></v-icon>
          </v-select>
        </v-row>
      </v-container>
    </v-card-text>
    <!-- <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="orange"
        text
        @click="setSelectedNodeID(null)"
      >
        Cancel
      </v-btn>
      <v-btn
        color="orange"
        text
        @click="onSubmit()"
      >
        Submit
      </v-btn>
    </v-card-actions> -->
  </draggable-modal>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import DraggableModal from './DragableModal.vue'

export default {
  name: 'NodePinsModal',
  data () {
    return {
      pinnedBy: []
    }
  },
  components: {
    DraggableModal
  },

  mounted () {

  },

  watch: {
    async selectedNodePinsID () {
      console.log('selectedNode changed')
      if (this.selectedNodePinsID !== null) {
        this.$refs.modal.show()
      } else {
        this.$refs.modal.hide()
      }
      console.log(this.selectedNode)

      if (this.selectedNodePinsID !== null) {
        console.log(this.selectedNode)
        this.pinnedBy = []
        for (var u of this.selectedNode.pinned) {
          var user = await this.requestSearchUserByUUID(u)
          this.pinnedBy.push(user)
        }
        console.log(this.pinnedBy)
      }
    }
  },
  computed: {
    ...mapState('canvas', ['selectedNodePinsID', 'nodeMap']),
    selectedNode () {
      return (this.selectedNodePinsID === null) ? {
        text: '',
        fill: '',
        font: '',
        fontColor: '',
        dotColor: ''
      } : this.nodeMap[this.selectedNodePinsID]
    }
  },
  methods: {
    ...mapMutations('canvas', ['setSelectedNodePinsID']),
    ...mapActions(['requestSearchUserByUUID', 'getAvatarFromUserName']),
    onSubmit () {
      let fill = this.selectedNode.fill
      this.colors.forEach(c => {
        if (this.color === c.label) {
          fill = c.code
        }
      })

      let fontVal = this.fonts[0].value
      this.fonts.forEach(f => {
        if (this.font === f.label) {
          fontVal = f.value
        }
      })

      let fontColorVal = this.selectedNode.fontColor
      this.fontColors.forEach(f => {
        if (this.fontColor === f.label) {
          fontColorVal = f.code
        }
      })

      let dotColorVal = this.selectedNode.dotColor
      this.dotColors.forEach(f => {
        if (this.dotColor === f.label) {
          dotColorVal = f.code
        }
      })

      let nodeText = this.text.trim()
      if (!nodeText.endsWith('?')) {
        nodeText += '?'
      }
      this.changeNodeText({
        nodeID: this.selectedNodeID,
        newText: nodeText
      })
      this.changeNodeFill({
        nodeID: this.selectedNodeID,
        newFill: fill
      })
      this.changeNodeFont({
        nodeID: this.selectedNodeID,
        newFont: fontVal
      })
      this.changeNodeFontColor({
        nodeID: this.selectedNodeID,
        newFontColor: fontColorVal
      })
      this.changeNodeDotColor({
        nodeID: this.selectedNodeID,
        newDotColor: dotColorVal
      })

      this.setSelectedNodeID(null)
    },
    onDelete () {
      this.deleteNode({
        nodeID: this.selectedNodeID
      })
      this.setSelectedNodeID(null)
    },
    resizeModal () {
      this.$refs.modal.recalculateSize()
    },
    async delay (func, ms) {
      return new Promise(() => setTimeout(func, ms))
    }
  }
}
</script>
